<template>
  <div class="field">
    <label class="label">Salary Expectations Comment</label>
    <div class="control">
      <input
        class="input"
        type="text"
        placeholder="..."
        :value="value"
        @input="updateValue"
        @focusout="handleChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PositionSalaryExpectationsComment',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    positionId: {
      type: Number,
      required: true
    }
  },
  methods: {
    updateValue (event) {
      this.$emit('input', event.target.value)
    },
    async handleChange () {
      try {
        await this.$network_utils.updatePosition({ position_id: this.positionId, salary_expectations_comment: this.value, active_at: new Date() })
        this.$utils.emit('show_toast', { text: 'Success' })
      } catch (e) {
        this.$utils.emit('show_toast', { text: 'failed' })
      }
    }
  }
}
</script>
